import React from 'react';
import { DropDown } from './common';
import { connect } from 'react-redux';
import { DuLieuHeThong } from 'api';

class DropDownChonTinhTrangTaiLieu extends React.Component {
  constructor(props, context) {
    super(props);
    this.state = {
      data: this.props.data
    }
  }

  componentDidMount() {
    if(this.props.data.length == 0) {
      DuLieuHeThong.actions.getTinhTrangTaiLieu.request().then(res => {
        this.props.dispatch({
          type: 'CAPNHAT_DULIEUHETHONG',
          duLieuHeThong: [{
            key: 'tinhTrangTaiLieuList',
            data: res.data || []
          }]
        })
      })
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.data != this.props.data) {
      this.state.data = nextProps.data;
      this.setState({...this.state})
    }
  }

  onChange(e) {
    this.props.onChange(e);
  }

  render() {
    return (
      <DropDown label={this.props.label} selectedValue={this.props.selectedValue} require={this.props.require} isValid={this.props.isValid} options={this.state.data} keyName='giaTri' valueName='ten' onChange={this.onChange.bind(this)} placeholder={this.props.placeholder} className={'col-input '+this.props.className} name={this.props.name}/>
    )
  }
}

DropDownChonTinhTrangTaiLieu.defaultProps = {
  className: 'input-group',
  onChange: function () {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  require: false,
  isValid: false,
  label: '',
  name: 'tinhTrangTaiLieu'
}

let bindStateToProps = state => {
  return {
    data: state.duLieuHeThong.tinhTrangTaiLieuList
  }
}

export default connect(bindStateToProps)(DropDownChonTinhTrangTaiLieu);



// WEBPACK FOOTER //
// ./src/components/tt-forms/dropdown-chontinhtrangtailieu.jsx